import type { OemContext } from '../../lib/auth';
import { GroupedNavigation } from './grouped-navigation';
import { primaryNavigation } from './workspace-model';
import { WorkspaceIcon } from './workspace-icons';
export function WorkspaceNavigation({
  context,
  currentPage,
  link,
  pins,
  onPinsChange,
}: {
  context: OemContext;
  currentPage: string;
  link: (key: string) => string;
  pins: string[];
  onPinsChange: (pins: string[]) => void;
}) {
  return (
    <div className="workspace-navigation">
      <nav className="primary-navigation" aria-label="เมนูหลัก">
        {primaryNavigation(context).map((item) => (
          <a
            key={item.page}
            href={link(item.page)}
            className={`nav-item ${currentPage === item.page ? 'current' : ''}`}
            aria-current={currentPage === item.page ? 'page' : undefined}
          >
            <WorkspaceIcon name={item.icon} />
            {item.label}
          </a>
        ))}
      </nav>
      <details className="additional-tools">
        <summary>เพิ่มเติม</summary>
        <GroupedNavigation
          audience={context.audience}
          currentPage={currentPage}
          link={link}
          pins={pins}
          onPinsChange={onPinsChange}
        />
      </details>
    </div>
  );
}
